import React, { useState, useRef } from 'react';
import Hero from './components/Hero.jsx';
import Calculator from './components/Calculator.jsx';
import Results from './components/Results.jsx';
import WorkedExample from './components/WorkedExample.jsx';
import Assumptions from './components/Assumptions.jsx';
import FAQ from './components/FAQ.jsx';
import NextSteps from './components/NextSteps.jsx';
import Footer from './components/Footer.jsx';
import './App.css';

function App() {
  const [inputs, setInputs] = useState(null);
  const [results, setResults] = useState(null);
  const calculatorRef = useRef(null);

  const handleStartClick = () => {
    calculatorRef.current?.scrollIntoView({ 
      behavior: 'smooth',
      block: 'start'
    });
  };

  const handleResults = (newInputs, newResults) => {
    setInputs(newInputs);
    setResults(newResults);
  };

  return (
    <div className="min-h-screen bg-white">
      <Hero onStartClick={handleStartClick} />
      
      <div ref={calculatorRef}>
        <Calculator onResults={handleResults} />
      </div>
      
      {results && (
        <Results inputs={inputs} results={results} />
      )}
      
      <WorkedExample />
      <Assumptions />
      <FAQ />
      <NextSteps />
      <Footer />
    </div>
  );
}

export default App;